import React from 'react';
import Header from '../components/Header';

export default function Favorites() {
  return (
    <>
      <Header />
      <h1>Favorites</h1>
    </>
  );
}
